export { AppStorageService, KEYS_APPSTORAGE } from 'sce-core';
// #TODO-LIBRARY AppStorageService Used in 6 places 6 files in WMS /src/app.. should be re-referenced from library directly



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/core/security/app-storage.service.ts